import { render, staticRenderFns } from "./TDSDatePicker.vue?vue&type=template&id=50ae48dd"
import script from "./TDSDatePicker.vue?vue&type=script&lang=ts"
export * from "./TDSDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./TDSDatePicker.vue?vue&type=style&index=0&id=50ae48dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports